// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLaserEmissionTriangleRed_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.8778 2.64916C11.382 1.78361 12.618 1.78362 13.1222 2.64916L23.8172 21.0089C24.3298 21.8889 23.7036 23 22.695 23H1.30499C0.296386 23 -0.329799 21.8889 0.182839 21.0089L10.8778 2.64916Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0256 14.5L20.8994 16H14.0588L16.8447 18.7859L15.7841 19.8466L13 17.0625V21H11.5V17.0608L8.71409 19.8467L7.65343 18.786L10.4395 16H6.5V14.5H10.4375L7.65234 11.7148L8.713 10.6542L11.5 13.4412V9.5H13V13.4395L15.7852 10.6543L16.8458 11.715L14.0608 14.5H20.0256Z" class="svg-fg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.5038 2.89645C15.1761 1.70118 16.8239 1.70118 17.4962 2.89645L31.7562 28.2504C32.4397 29.4657 31.6048 31 30.26 31H1.73999C0.395181 31 -0.439731 29.4657 0.243785 28.2504L14.5038 2.89645Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.666 19.1992L27.6784 20.9992H18.0751L22.1244 25.0485L20.8516 26.3213L16.8008 22.2705V27.9992H15.0008L15.0008 22.3263L11.0604 26.4066L9.76562 25.1562L13.78 20.9992H8V19.1992H13.7295L9.67928 15.149L10.9521 13.8762L15.0008 17.9249L15.0008 12.1992H16.8008V17.8711L20.7412 13.7907L22.036 15.0411L18.0206 19.1992H26.666Z" class="svg-fg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M30.2488 5.17397C31.0094 3.79551 32.9906 3.79551 33.7512 5.17397L62.3635 57.0338C63.0989 58.3668 62.1347 60 60.6123 60H3.38765C1.86528 60 0.901074 58.3668 1.6365 57.0338L30.2488 5.17397Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M52.9655 40L54.069 42H37.0458L41.6261 43.89L40.8633 45.7388L36.2513 43.8357L44.7291 52.3136L43.3149 53.7278L34.8517 45.2646L36.754 49.8561L34.9062 50.6216L33 46.0204V58H31V46.0462L29.1105 50.6254L27.2617 49.8625L29.1637 45.253L20.6888 53.7279L19.2746 52.3137L27.6985 43.8898L23.168 45.7897L22.3945 43.9453L27.0334 42H15V40H26.9553L22.3753 38.1102L23.1382 36.2614L27.7524 38.1653L19.2733 29.6862L20.6875 28.272L29.1548 36.7393L27.2512 32.1446L29.0989 31.3791L31 35.9677V24H33V35.9558L34.8903 31.3746L36.7391 32.1374L34.8341 36.7542L43.3163 28.2721L44.7305 29.6863L36.3047 38.112L40.8384 36.2108L41.6119 38.0552L36.9743 40H52.9655Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedLaserEmissionTriangleRed is a generated icon component.
 */
let IconMedLaserEmissionTriangleRed = IconMedLaserEmissionTriangleRed_1 = class IconMedLaserEmissionTriangleRed extends IconBaseElement {
    render() {
        return html `${IconMedLaserEmissionTriangleRed_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLaserEmissionTriangleRed.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedLaserEmissionTriangleRed = IconMedLaserEmissionTriangleRed_1 = __decorate([
    customElement('zui-icon-med-laser-emission-triangle-red')
], IconMedLaserEmissionTriangleRed);
export { IconMedLaserEmissionTriangleRed };
